import { Ref } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import EmailUnlayerSection, { EmailUnlayerHandle } from '../EmailUnlayerSection';
import { readRichSmsContent } from '../creationPayload';

interface RichSmsStepProps {
  payload: Record<string, unknown> | null;
  ref: Ref<EmailUnlayerHandle>;
}

function RichSmsStep({ payload, ref }: RichSmsStepProps) {
  return (
    <Box sx={{ p: 3, width: '100%' }}>
      <Typography variant="body2" fontWeight={600} sx={{ mb: 1.5 }}>
        Landing page du SMS enrichi
      </Typography>
      <Alert severity="info" sx={{ mb: 2, fontSize: '0.8rem' }}>
        Le token <strong>#SHORT_URL#</strong> sera automatiquement inséré dans votre message et pointera vers cette landing page.
      </Alert>
      <EmailUnlayerSection ref={ref} isLandingPage initialContent={readRichSmsContent(payload)} />
    </Box>
  );
}

export default RichSmsStep;
